export * from './js'

import { account } from './vuex'
import { factors } from './vuex'
import { kyc } from './vuex'
import { wallet } from './vuex'

export const vuexModules = {
  account,
  factors,
  kyc,
  wallet
}
export { vuexTypes } from './vuex'
